import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./policy-page-style.css";
import SiteFooter from "../../custom/site-footer/site-footer";
import PageSeo from "../../custom/page-seo/page-seo";
import useIsMobile from "../../../hooks/useIsMobile";

//隱私權政策與使用條款
//  一頁兩區塊，用 tab 切換：
//    ?tab=privacy → 隱私權政策
//    ?tab=terms   → 使用條款
//  預設 privacy
const PolicyPageComponent = ({ setShowServiceMenu, setShowPersonalMenu }) => {
  const isMobile = useIsMobile();
  const [searchParams, setSearchParams] = useSearchParams();
  const initTab = searchParams.get("tab") === "terms" ? "terms" : "privacy";
  const [activeTab, setActiveTab] = useState(initTab);

  //切 tab 時同步 URL query string，方便 SiteFooter 之後可直接連 /policy?tab=terms
  const changeTab = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab }, { replace: true });
  };

  useEffect(() => {
    const t = searchParams.get("tab");
    if (t === "terms" || t === "privacy") setActiveTab(t);
  }, [searchParams]);

  //量測 sticky nav 高度（同 checkout 頁）避免內容被 nav 蓋
  const [navHeight, setNavHeight] = useState(0);
  useEffect(() => {
    const nav = document.querySelector(
      isMobile ? ".mobile-dashboard nav" : ".dashboard nav",
    );
    setNavHeight(nav ? nav.offsetHeight : 0);
  }, [isMobile]);

  const renderPrivacy = () => (
    <div className="policy-doc">
      <p className="doc-updated">最後更新日期：2026 年 07 月 07 日</p>

      <p className="doc-intro">
        萊諾創新科技有限公司（下稱「本公司」）經營之「元辰雲閣」網站（
        <a href="https://yuanchen.leinotek.com">https://yuanchen.leinotek.com</a>
        ，下稱「本服務」）非常重視您的個人資料保護。本政策說明我們如何蒐集、處理、利用您的個人資料，並依中華民國《個人資料保護法》及相關法令辦理。使用本服務即表示您已閱讀並同意本政策全部內容。
      </p>

      <h2>一、適用範圍</h2>
      <p>
        本政策僅適用於本服務所蒐集之個人資料。當您點擊本網站中之外部連結（如綠界科技、Google
        LINE 官方帳號等），請另行參閱該第三方服務之隱私權政策。
      </p>

      <h2>二、我們蒐集哪些個人資料</h2>
      <p>為提供命理分析與相關服務，本服務可能蒐集以下類別之個人資料：</p>
      <ul>
        <li>
          <strong>帳戶識別資料：</strong>透過 Google
          第三方帳號登入所取得之電子郵件、姓名、頭像。
        </li>
        <li>
          <strong>命理分析所需資料：</strong>暱稱、出生年月日、出生時辰、出生地經緯度、性別、感情/家庭狀況、身份別等。
        </li>
        <li>
          <strong>交易與發票資料：</strong>訂單編號、金額、付款方式（信用卡末四碼由綠界處理，我方不留存）、電子發票資訊（載具號碼、統一編號、抬頭、通知
          Email、捐贈碼等）。
        </li>
        <li>
          <strong>使用行為與內容：</strong>您產生的
          AI 命理報告、書房紀錄、簽到紀錄、A-Point 交易紀錄、專業諮詢對話紀錄。
        </li>
        <li>
          <strong>技術資料：</strong>裝置類型、瀏覽器資訊、Cookie、伺服器
          log（供資安、除錯與服務穩定用）。
        </li>
      </ul>

      <h2>三、蒐集目的與利用方式</h2>
      <ul>
        <li>提供命理分析、AI 報告產出、專業諮詢等本服務之核心功能。</li>
        <li>處理訂單、開立電子發票、退款與客戶服務。</li>
        <li>寄送與服務相關之交易通知（如發票、購買確認）。</li>
        <li>統計分析、產品改善與服務品質提升（僅使用去識別化資料）。</li>
        <li>依法律或主管機關要求提供必要資訊。</li>
      </ul>
      <p>
        本服務<strong>不會將您的個人資料作為行銷用途</strong>，除非您另行明示同意。
      </p>

      <h2>四、保存期間</h2>
      <p>
        您的個人資料原則上保存至您註銷帳戶止；發票、交易與稅務相關紀錄依《稅捐稽徵法》規定保存 5 年；伺服器 log 保存 30 日。您可隨時要求刪除。
      </p>

      <h2>五、資料提供與第三方分享</h2>
      <p>本服務為完成上述目的，會將必要資料提供給下列合作對象：</p>
      <ul>
        <li>
          <strong>綠界科技（ECPay）：</strong>金流付款處理、電子發票代開立。
        </li>
        <li>
          <strong>Google Cloud / Firebase：</strong>帳號驗證、檔案儲存、應用程式運算。
        </li>
        <li>
          <strong>Anthropic Claude / Google Gemini：</strong>AI
          命理報告產出；僅傳送必要之命盤、生日等資訊，並要求供應商依合約不得留存訓練。
        </li>
        <li>
          <strong>其他：</strong>因法律要求或司法機關依法函詢時。
        </li>
      </ul>
      <p>
        除上述情形外，本服務<strong>不會將您的個人資料販售、出租或提供給任何第三方</strong>。
      </p>

      <h2>六、您的權利</h2>
      <p>依個人資料保護法第 3 條，您可隨時就本服務保有之個人資料主張下列權利：</p>
      <ul>
        <li>查詢或請求閱覽</li>
        <li>請求製給複製本</li>
        <li>請求補充或更正</li>
        <li>請求停止蒐集、處理或利用</li>
        <li>請求刪除</li>
      </ul>
      <p>
        請寄信至{" "}
        <a href="mailto:yuanchencloud@gmail.com">yuanchencloud@gmail.com</a>{" "}
        主張，我方將於 7 個工作天內回覆處理。
      </p>

      <h2>七、Cookie 與追蹤技術</h2>
      <p>
        本服務使用 httpOnly Cookie
        儲存您的登入狀態，屬服務運行所必要，關閉將導致無法使用本服務。本服務目前不使用第三方廣告追蹤 Cookie。
      </p>

      <h2>八、未成年人保護</h2>
      <p>
        本服務適用對象為年滿 18 歲之個人。未滿 18
        歲者，請於法定代理人陪同並取得同意後始得使用本服務及提供個人資料。
      </p>

      <h2>九、資料安全</h2>
      <p>
        本服務採用 HTTPS 加密傳輸；資料儲存於 MongoDB Atlas 及 Firebase Storage
        並依環境隔離；發票與敏感 credentials 存放於 Google Cloud Secret
        Manager。我方仍無法保證絕對安全，敬請您妥善保管帳號並避免於公用電腦登入。
      </p>

      <h2>十、政策修訂</h2>
      <p>
        本政策可能因法規或服務變動而修訂，修訂後將於本頁公告並更新「最後更新日期」；重大變更將透過 Email 或站內公告通知。
      </p>

      <h2>十一、聯絡我們</h2>
      <p>
        本政策相關問題，或欲行使個資權利者，請寄信至：{" "}
        <a href="mailto:yuanchencloud@gmail.com">yuanchencloud@gmail.com</a>
      </p>
    </div>
  );

  const renderTerms = () => (
    <div className="policy-doc">
      <p className="doc-updated">最後更新日期：2026 年 07 月 07 日</p>

      <p className="doc-intro">
        歡迎使用「元辰雲閣」（下稱「本服務」）。本使用條款（下稱「本條款」）為您（下稱「使用者」）與萊諾創新科技有限公司（下稱「本公司」）間之契約。使用本服務即視為您已閱讀並同意本條款全部內容。若不同意，請立即停止使用。
      </p>

      <h2>一、服務內容</h2>
      <p>本服務提供之項目包含但不限於：</p>
      <ul>
        <li>個人專屬命盤解析、七大面向分析</li>
        <li>流年之書、真愛合盤、親子合盤等 AI 命理報告</li>
        <li>奇門遁甲吉時查詢</li>
        <li>問問老師專業命理諮詢</li>
        <li>A-Point 點數儲值與使用</li>
      </ul>

      <h2>二、帳號註冊與使用資格</h2>
      <ul>
        <li>使用者須透過 Google 帳號登入並完成註冊資料填寫。</li>
        <li>使用者應確保所提供之資料真實、正確且完整。</li>
        <li>
          使用者須年滿 18 歲；未滿 18 歲者，須經法定代理人同意始得使用本服務。
        </li>
        <li>
          帳號不得轉讓、出借或販售；因帳號被盜用致生之損害，除可歸責本公司者外，由使用者自行負責。
        </li>
      </ul>

      <h2>三、命理服務性質聲明（免責）</h2>
      <p>
        本服務所提供之命理分析、AI 報告及諮詢內容，屬於<strong>傳統東方文化參考</strong>，
        <strong>不構成醫療、法律、投資、婚姻或其他重大決策之專業建議</strong>。使用者不得依本服務內容作為前述決策之唯一或主要依據；因參考本服務內容所生之任何損害，本公司概不負責。
      </p>

      <h2>四、訂購、付款與電子發票</h2>
      <ul>
        <li>本服務所有訂購由綠界科技（ECPay）處理付款，本公司不留存信用卡完整資訊。</li>
        <li>
          付款完成後，本服務將依中華民國《統一發票使用辦法》開立電子發票，並依您選擇之類型（會員電子發票／手機條碼載具／捐贈／統一編號）處理。
        </li>
        <li>發票通知將寄至您於結帳頁提供之 Email。</li>
      </ul>

      <h2>五、退款政策</h2>
      <p>
        依《消費者保護法》第 19
        條第 2 項及《通訊交易解除權合理例外情事適用準則》第 2 條第 5 款，
        <strong>「非以有形媒介提供之數位內容或一經提供即為完成之線上服務」不適用七日鑑賞期</strong>。因此：
      </p>
      <ul>
        <li>
          <strong>AI 命理報告、奇門吉時查詢、專業諮詢：</strong>
          一經產出或提供即完成服務，恕不接受退款。
        </li>
        <li>
          <strong>A-Point 儲值：</strong>
          儲值成功後點數不得轉讓、不得退換現金；因系統錯誤或重複扣款所生之爭議，請於 7 日內來信申訴，經核實後將全額退款。
        </li>
        <li>
          <strong>電子發票作廢：</strong>
          若您因退款需求辦理發票作廢，本公司將於當月內作廢；跨月則以折讓單處理。
        </li>
      </ul>

      <h2>六、智慧財產權</h2>
      <p>
        本服務所產出之
        AI 報告內容，其著作權由本公司保留，僅授權使用者個人非商業使用；未經書面同意，不得複製、散布、公開傳輸、改作或商業利用。
      </p>

      <h2>七、禁止行為</h2>
      <p>使用本服務時，您不得：</p>
      <ul>
        <li>冒用他人身份、提供不實資料或干擾其他使用者權益。</li>
        <li>對本服務或其伺服器進行未授權之爬蟲、掃描、破解、逆向工程或壓力測試。</li>
        <li>將本服務用於違法目的、詐騙、賭博、或違反公序良俗之用途。</li>
        <li>未經授權將本服務轉售、代購、或作為商業媒介。</li>
      </ul>
      <p>違反上述規定者，本公司得逕行暫停或終止您的帳號並保留法律追訴權利。</p>

      <h2>八、服務中斷與變更</h2>
      <p>
        本公司得為系統維護、升級、修繕、法規變更或不可抗力事由，暫時中斷或永久終止全部或部分服務。除故意或重大過失外，本公司不對前述情事所致之損害負責。
      </p>

      <h2>九、免責條款</h2>
      <ul>
        <li>命理分析結果為文化參考性質，不保證任何預測結果之實現。</li>
        <li>
          AI 產出之報告可能存在資料誤差或詮釋差異，本公司力求準確但不擔保絕對正確。
        </li>
        <li>本公司對於因網路壅塞、第三方服務中斷所致之損害不負賠償責任。</li>
      </ul>

      <h2>十、條款修訂</h2>
      <p>
        本條款可能因法規或服務變動而修訂，修訂後將於本頁公告。使用者於修訂後繼續使用本服務，視為同意修訂內容。重大變更將另行 Email 或站內通知。
      </p>

      <h2>十一、準據法與管轄</h2>
      <p>
        本條款之解釋及適用，以及使用者與本公司間因本服務產生之爭議，均以中華民國法律為準據法，並合意以<strong>臺灣臺北地方法院</strong>為第一審管轄法院。
      </p>

      <h2>十二、聯絡我們</h2>
      <p>
        對本條款有任何疑問，請寄信至：{" "}
        <a href="mailto:yuanchencloud@gmail.com">yuanchencloud@gmail.com</a>
      </p>
    </div>
  );

  return (
    <div
      className="policy-page"
      onMouseEnter={() => {
        setShowServiceMenu(false);
        setShowPersonalMenu(false);
      }}
    >
      <PageSeo
        title="隱私權政策與使用條款｜元辰雲閣"
        description="元辰雲閣的隱私權政策與使用條款，說明個人資料的蒐集、處理、利用方式，以及使用本服務的相關規範。"
        path="/policy"
      />

      {!isMobile && (
        <div className="web-main">
          <div className="policy-content">
            <p className="page-title">隱私權政策與使用條款</p>

            <div className="tab-switcher">
              <button
                className={`tab-btn${activeTab === "privacy" ? " active" : ""}`}
                onClick={() => changeTab("privacy")}
              >
                隱私權政策
              </button>
              <button
                className={`tab-btn${activeTab === "terms" ? " active" : ""}`}
                onClick={() => changeTab("terms")}
              >
                使用條款
              </button>
            </div>

            {activeTab === "privacy" ? renderPrivacy() : renderTerms()}
          </div>
          <SiteFooter />
        </div>
      )}

      {isMobile && (
        <div
          className="mobile-main"
          style={{ paddingTop: navHeight + 20 }}
        >
          <div className="policy-content">
            <p className="page-title">隱私權政策與使用條款</p>

            <div className="tab-switcher">
              <button
                className={`tab-btn${activeTab === "privacy" ? " active" : ""}`}
                onClick={() => changeTab("privacy")}
              >
                隱私權政策
              </button>
              <button
                className={`tab-btn${activeTab === "terms" ? " active" : ""}`}
                onClick={() => changeTab("terms")}
              >
                使用條款
              </button>
            </div>

            {activeTab === "privacy" ? renderPrivacy() : renderTerms()}
          </div>
          <SiteFooter />
        </div>
      )}
    </div>
  );
};

export default PolicyPageComponent;
